import React, { useState, useEffect } from "react"
import Grid from "@material-ui/core/Grid"
import Layout from "../components/layout"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons"
import { faAngleRight } from "@fortawesome/free-solid-svg-icons"
import { faPause } from "@fortawesome/free-solid-svg-icons"
import { faPlay } from "@fortawesome/free-solid-svg-icons"
import { faCircle } from "@fortawesome/free-solid-svg-icons"
import PremiumServices from "../components/Sidebar/PremiumServices"
import Seo from "../components/seo"

const Radar = () => {
  let [count, setCount] = useState(1)
  const [auto, setAuto] = useState(true)
  const [autoPlayId] = useState(0)
  var d = new Date()
  const [modifier, setMod] = useState(d.getTime());
  const [image1] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite01.JPG`)
  const [image2] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite02.JPG`)
  const [image3] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite03.JPG`)
  const [image4] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite04.JPG`)
  const [image5] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite05.JPG`)
  const [image6] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite06.JPG`)
  const [image7] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite07.JPG`)
  const [image8] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite08.JPG`)
  const [image9] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite09.JPG`)
  const [image10] = useState(`${process.env.MET_SATELLITEIMAGE}/Satellite10.JPG`)

  useEffect(() => {
    var refreshid = setInterval(updateImages, 180000)
    if (auto) {
      var autoplayid = setInterval(updateTime, 1200)
    }
    return () => {
      clearInterval(refreshid)
      clearInterval(autoplayid)
    }
  })

  const updateTime = () => {
    if (count !== 10) setCount(count + 1)
    else setCount(1)
  }

  const updateImages = () => {
    var d = new Date()
    setMod(d.getTime())
  }

  const handleIncrement = () => {
    if (count !== 10) {
      setCount(count + 1)
      setAuto(false)
    } else {
      setCount(1)
      setAuto(false)
      return () => clearInterval(autoPlayId)
    }
  }
  const handleDecrement = () => {
    if (count !== 1) {
      setCount(count - 1)
    } else {
      setCount((count = 10))
    }
    setAuto(false)
    clearInterval(autoPlayId)
  }
  const handleAutoPlay = () => {
    setAuto(!auto)
    return () => clearInterval(autoPlayId)
  }

  const changeSlide = countNumber => {
    setCount((count = countNumber))
    setAuto(false)
  }

  return (
    <React.Fragment>
      <Layout>
      <Seo title="Channel Islands weather satellite images" description="Channel Islands weather satellite images" />
      <div className="forecastAutoMargin">
      <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <h1>
                  Satellite image
                  </h1>                  
      </Grid>
          <Grid container spacing={2}>
            <Grid item className="autoChangeImg" xs={12} sm={12} md={8} lg={8}>
              <React.Fragment>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", paddingTop: "40px" }}>
                      <img
                        style={count !== 1 ? { display: "none" } : {}}
                        alt="radar1"
                        src={image1 + "?" + modifier}
                      />
                      <img
                        style={count !== 2 ? { display: "none" } : {}}
                        alt="radar2"
                        src={image2 + "?" + modifier}
                      />
                      <img
                        style={count !== 3 ? { display: "none" } : {}}
                        alt="radar3"
                        src={image3 + "?" + modifier}
                      />
                      <img
                        style={count !== 4 ? { display: "none" } : {}}
                        alt="radar4"
                        src={image4 + "?" + modifier}
                      />
                      <img
                        style={count !== 5 ? { display: "none" } : {}}
                        alt="radar5"
                        src={image5 + "?" + modifier}
                      />
                      <img
                        style={count !== 6 ? { display: "none" } : {}}
                        alt="radar6"
                        src={image6 + "?" + modifier}
                      />
                      <img
                        style={count !== 7 ? { display: "none" } : {}}
                        alt="radar7"
                        src={image7 + "?" + modifier}
                      />
                      <img
                        style={count !== 8 ? { display: "none" } : {}}
                        alt="radar8"
                        src={image8 + "?" + modifier}
                      />
                      <img
                        style={count !== 9 ? { display: "none" } : {}}
                        alt="radar9"
                        src={image9 + "?" + modifier}
                      />
                      <img
                        style={count !== 10 ? { display: "none" } : {}}
                        alt="radar10"
                        src={image10 + "?" + modifier}
                      />
                    <div className="Slides">
                      <div style={{width: "100%", textAlign: "center", marginTop: "10px"}}>
                        {count === 1 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(1)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(1)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 2 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(2)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(2)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 3 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(3)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(3)} icon={faCircle} className="nonActiveCircle"
                          />
                        )}
                        {count === 4 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(4)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(4)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 5 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(5)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(5)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 6 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(6)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(6)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 7 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(7)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(7)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 8 ? (
                          <FontAwesomeIcon  onClick={() => changeSlide(8)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon  onClick={() => changeSlide(8)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 9 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(9)} icon={faCircle} className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(9)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                        {count === 10 ? (
                          <FontAwesomeIcon onClick={() => changeSlide(10)} icon={faCircle}  className="activeCircle"/>
                        ) : (
                          <FontAwesomeIcon onClick={() => changeSlide(10)} icon={faCircle} className="nonActiveCircle"/>
                        )}
                      </div>

                      <div style={{marginLeft: "18px", marginRight: "15px", marginTop: "10px", marginBottom: "20px"}}>
                        <button
                          onClick={handleDecrement}
                          className="sliderButton"
                        >
                          <FontAwesomeIcon icon={faAngleLeft} />
                        </button>
                        &nbsp;
                        <button
                          onClick={handleIncrement}
                          className="sliderButton"
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                        </button>
                        &nbsp;
                        {auto ? (
                          <button
                            onClick={handleAutoPlay}
                            className="sliderButton"
                          >
                            <FontAwesomeIcon
                              style={{ marginRight: "5px" }}
                              icon={faPause}
                            />
                            Pause
                          </button>
                        ) : (
                          <button
                            onClick={handleAutoPlay}
                            className="sliderButton"
                          >
                            <FontAwesomeIcon
                              style={{ marginRight: "5px" }}
                              icon={faPlay}
                            />
                            Play
                          </button>
                        )}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </React.Fragment>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
                  <PremiumServices />
                </Grid>
          </Grid>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default Radar
